import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ORingSizeChartAs568Component } from './o-ring-size-chart-as568.component';

const routes: Routes = [
  {
    path: '',
    component: ORingSizeChartAs568Component,
    data: {
      meta: {
        title: 'AS568 O-Ring Size Chart | Marco Sealing Solutions',
        description: 'Interactive standard o-ring size chart to find Parker and AS568 o-ring size dimensions. Order Online millions of o-ring sizes are in-stock'
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class ORingSizeChartAs568RoutingModule { }
